<template>
  <AdminLayout><AdminProfile /></AdminLayout>
</template>

<script>
import AdminLayout from './AdminLayout.vue';
import AdminProfile from './AdminProfile.vue';

export default {
  name: 'AdminHome',
  components: { AdminLayout, AdminProfile },
};
</script>
